import { Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSlideToggle } from '@angular/material/slide-toggle';

import { SettingsSliderTestIds } from './settings-slider.test-ids';

@Component({
  selector: 'app-settings-slider',
  imports: [FormsModule, MatSlideToggle],
  templateUrl: './settings-slider.component.html',
  styleUrl: './settings-slider.component.scss'
})
/**
 * Allgemeine Komponente für den Mat-slider-toggle, wie er in den Settings häufiger genutzt wird.
 * Begründung: Dies erfüllt keine AFO
 */
export class SettingsSliderComponent {
  protected readonly testIds = SettingsSliderTestIds;
  disabled = input<boolean>(false);
  change = input<() => void>();
  modelNg = model<boolean>(false);
  choiceDescriptor = input<string>('');
  settingDescriptor = input<string>('');

  onChange(checked: boolean): void {
    this.modelNg.update(() => checked);
    this.change();
  }
}
